import React from "react";
import { FaHourglassHalf, FaClock, FaCheckCircle } from "react-icons/fa";


export const makeAssType_11 = ({ book, user }) => ({
    2: {
        STEP1: {
            book_asin: book.selectedCurrentUserAssign?.book?.paper_back_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaHourglassHalf
                className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite"
                size={15} />,
            title1: "Search and Buy the Paperback",
            description1: "Use the search link below to find and purchase the book. Then click the 'Next Step' button.",

            icon2: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Upload proof of purchase",
            description2: "Upload a clear screenshot/photo of your Amazon order. Reading the book is up to you.",

            icon3: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "Submit the assignment. Verification will be completed after we review your files.",

            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Reimbursement & Virt credit",
            description4: "After verification, you’ll receive Virt + reimbursement of the book price (excluding delivery).",

            // ===== Expanded step panels =====
            full_title1: `Find and Purchase the Paperback by Search phrase. Reimbursement: +$${book.selectedCurrentUserAssign?.book_cost_compensation ?? book.selectedCurrentUserAssign?.assignment_price_amz ?? 'the book’s retail price'} (excluding delivery)`,
            full_subtitle1: "No public review required. Proof of purchase is mandatory.",
            full_description1: (
                <p>
                    Find the <b>Paperback edition</b> on Amazon using the <b>search phrase provided by the author</b>.
                    Do <b>not</b> use direct links — locate the book manually by title or author name.
                    Purchase it using your own Amazon account (no used or third-party copies).
                    You’ll receive a full reimbursement of the <b>book’s retail price (excluding delivery)</b> after verification.
                    Click the button below to open Amazon and complete your order.
                </p>
            ),

            full_title2: "Upload your purchase proof and book photo",
            full_subtitle2: "Make sure both images are clear and readable.",
            full_description2: (
                <p>
                    Please upload a <b>screenshot of your Amazon purchase receipt</b> showing the
                    order ID, book title (or ASIN), order date, price, and your Amazon account name —
                    <b>and a photo of the physical book you received in the Amazon package</b>.
                    Both files must be clear and readable. Blurred or cropped images may be rejected.
                </p>
            ),

            full_title3: "Turn in this assignment",
            full_subtitle3: "Submit after uploading your proof.",
            full_description3: (
                <p>
                    Click the button below to submit. Our team will verify the order against Amazon.
                    If anything is missing, we’ll ask you to re-upload or provide additional details.
                </p>
            ),

            full_title4: "Receive reimbursement & Virt",
            full_subtitle4: "You’ll get reimbursed for the retail price and rewarded with Virt after verification.",
            full_description4: (
                <p>
                    After our team verifies your proof of purchase, we will credit your <b>Virt</b>
                    and reimburse the <b>book’s retail price (excluding delivery)</b> according to assignment terms.
                    Thank you for completing the <b>Paperback Search & BuyOut</b> task and helping us confirm genuine Amazon purchases!
                </p>
            ),
        },
        STEP2: {
            book_asin: book.selectedCurrentUserAssign?.book?.paper_back_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title1: "Search and Buy the Paperback",
            description1: "You have completed this step!",

            icon2: <FaHourglassHalf
                className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite"
                size={15}/>,
            title2: "Upload proof of purchase",
            description2: "Please upload a clear screenshot or photo of your Amazon order. Reading the book is optional.",

            icon3: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "Submit the assignment. Verification will be completed after we review your files.",

            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Reimbursement & Virt credit",
            description4: "After verification, you’ll receive Virt + reimbursement of the book price (excluding delivery).",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "Upload your purchase proof and book photo",
            full_subtitle2: "Make sure both images are clear and readable.",
            full_description2: (
                <p>
                    Please upload a <b>screenshot of your Amazon purchase receipt</b> showing the
                    order ID, book title (or ASIN), order date, price, and your Amazon account name —
                    <b>and a photo of the physical book you received in the Amazon package</b>.
                    Both files must be clear and readable. Blurred or cropped images may be rejected.
                </p>
            ),

            full_title3: "Turn in this assignment",
            full_subtitle3: "After uploading your proof, please submit this assignment so that our team can begin the verification process.",
            full_description3: (
                <p>
                    Click the button below to submit. Our team will verify the order against Amazon after reviewing your files.
                    If anything is missing, we’ll ask you to re-upload or provide additional details.
                </p>
            ),

            full_title4: "Receive reimbursement & Virt",
            full_subtitle4: "Reimbursement excludes delivery; additional Virt will be credited after approval.",
            full_description4: (
                <p>
                    Once verified, we will credit your <b>Virt</b> and reimburse the <b>book’s retail price (excluding delivery)</b>
                    according to the assignment terms. Thanks for completing the BuyOut assignment!
                </p>
            ),
        },
        STEP3: {
            book_asin: book.selectedCurrentUserAssign?.book?.paper_back_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title1: "Search and Buy the Paperback",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title2: "Upload proof of purchase",
            description2: "Your proof has been successfully uploaded — excellent work completing this step! Keep it up!",

            icon3: <FaHourglassHalf
                className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite"
                size={15}/>,
            title3: "Turn in this assignment",
            description3: "You are on the third step now! Click “Turn In” to submit your assignment to start verification process.",

            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Reimbursement & Virt credit",
            description4: "After verification, you’ll receive Virt + reimbursement of the book price (excluding delivery).",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "",
            full_subtitle2: "",
            full_description2: "",

            full_title3: "Turn in this assignment",
            full_subtitle3: "After uploading your proof, please submit this assignment so that our team can begin the verification process.",
            full_description3: (
                <p>
                    Click the button below to submit. Our team will verify the order against Amazon after reviewing your files.
                    If anything is missing, we’ll ask you to re-upload or provide additional details.
                </p>
            ),


            full_title4: "Verification in progress",
            full_subtitle4: "We’ll review your files and confirm order details.",
            full_description4: (
                <p>
                    Our team will check your review on Amazon and validate the purchase details from your
                    uploaded files.
                    If anything is missing or unclear, we’ll ask you to re-upload or provide additional
                    information.
                    Once approved, we’ll credit your <b>Virt</b> and reimburse the <b>book’s retail price
                    (excluding delivery)</b>.
                </p>
            ),
        },
        STEP4: {
            book_asin: book.selectedCurrentUserAssign?.book?.paper_back_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title1: "Search and Buy the Paperback",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title2: "Upload proof of purchase",
            description2: "Your proof has been successfully uploaded — excellent work completing this step! Keep it up!",

            icon3: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "Your assignment has been submitted! You’ll be notified once the assignment is complete.",

            icon4: <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15} />,
            title4: "Awaiting verification & payout",
            description4: "We received your submission. We’ll verify it and credit upon approval. You’ll be notified soon.",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "",
            full_subtitle2: "",
            full_description2: "",

            full_title3: "",
            full_subtitle3: "",
            full_description3: "",

            full_title4: "Verification & reimbursement in progress",
            full_subtitle4: "We’re reviewing your files and confirming order details.",
            full_description4: (
                <>
                    Our team is verifying your purchase with the provided screenshots/photos and Amazon order details.
                    If anything is missing or unclear, we’ll ask you to re-upload the files. Once approved, we will
                    credit your <b>Virt</b> and reimburse the <b>book’s retail price (excluding delivery)</b> according
                    to the assignment terms.
                </>
            ),
        },
        STEP5: {
            book_asin: book.selectedCurrentUserAssign?.book?.paper_back_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title1: "Search and Buy the Paperback",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title2: "Upload proof of purchase",
            description2: "We’ve reviewed and validated your proof — all good, nicely done and confirmed!",

            icon3: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title3: "Turn in this assignment",
            description3: "Assignment submitted successfully and verified — great job completing it thoroughly and fast!",

            icon4: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title4: "Assignment confirmed!",
            description4: "Congratulations, your BuyOut assignment is fully confirmed! Virt + reimbursement credited.",

            // ===== Expanded step panels =====
            full_title5: "Congratulations, this assignment is fully confirmed!",
            full_subtitle5: "Your Virt and reimbursement have been successfully credited.",
            full_description5: (
                <p>
                    This BuyOut assignment is now closed. You have received your <b>Virt</b> and reimbursement of the
                    <b> book’s retail price (excluding delivery)</b>. Please note that if verification later reveals
                    discrepancies in your submitted files, adjustments to your balance may still be required.
                    Thank you for completing the assignment!
                </p>
            ),

            verified_purchase: "Not required",
            photo: "Not needed",
            review_name: user?.user?.amz_name || "Not found",
            review_site: user?.user?.amz_country || "Amazon",
        },
    },
});
